// extracted by mini-css-extract-plugin
export default {"generate-result":"ResultStoryModal_generate-result__DvWQB","modal-window":"ResultStoryModal_modal-window__Rz9bN","result-story-btn":"ResultStoryModal_result-story-btn__z2VLb"};